import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import get from 'lodash/get';
import replace from 'lodash/replace';

import Button from '../../../../components/Button';
import TextButton from '../../../../components/TextButton';
import NewWindowLink from '../../../../components/NewWindowLink';
import NextLink from '../../../../components/NextLink';
import ActionStatusModal from '../../../../components/ActionStatusModal';
import ParseHtml from '../../../../components/ParseHtml';
import route, { actionsPagesRoutes } from '../../../../constants/routes';
import { getRouteWithSlug } from '../../../../utils/common';
import { TP } from '../../../../constants/consts';

const useStyles = makeStyles(() => ({
  suggestionsBlock: {
    overflow: 'auto',
    width: '100%',
    height: '80%',
    paddingRight: 10,
  },
  suggestedArtist: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  modalSubtitle: {
    opacity: 0.8,
    textAlign: 'center',
    marginTop: 20,
  },
}));

const SuggestionArtistsModal = ({
  agencyData,
  artistSuggestionsList,
  closeModal,
  t,
  isOpened,
  addToRoster,
  selectArtist,
  type,
  mainText,
  confirmButtonText,
}) => {
  const classes = useStyles();

  const [title, setTitle] = useState(`${TP}.PAYMENT_DETAILS_DIALOG_DELETE_TITLE`);
  const [text, setText] = useState(mainText);
  const [buttons, setButtons] = useState([
    <TextButton textView onClick={closeModal} key="SuggestionArtistsModal-cancel-button">
      {t(`${TP}.m_CANCEL`)}
    </TextButton>,
    <Button
      key="SuggestionArtistsModal-confirm-new-artist-button"
      onClick={() => {
        closeModal();
        addToRoster();
      }}
    >
      {t(confirmButtonText)}
    </Button>,
  ]);

  useEffect(() => {
    if (type === 'duplicate') {
      setTitle(`${TP}.m_ROSTER_POPUP_DUPLICATE_TITLE`);
      setText(`${TP}.m_ROSTER_POPUP_TEXT_DUPLICATE`);
      setButtons([
        <Button key="SuggestionArtistsModal-go-back-button" onClick={closeModal}>
          {t(`${TP}.m_PAYMENT_ARTIST_BACKHOME`)}
        </Button>,
      ]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addToRoster, closeModal, type]);

  const contactEmail = '<a href="mailto: contact@operabase.com">contact@operabase.com</a>';

  return (
    <ActionStatusModal type="warning" title={t(title)} isOpened={isOpened} onClose={closeModal} buttons={buttons}>
      <div>
        {type === 'duplicate' ? <ParseHtml>{replace(t(text), '%s', contactEmail)}</ParseHtml> : t(text)}
        <div className={classes.modalSubtitle}>{t(`${TP}.m_ROSTER_DUPLICATE_TITLE`)}</div>
      </div>
      <div className={classes.suggestionsBlock}>
        {artistSuggestionsList.map(artistSuggested => {
          const profession =
            get(artistSuggested, 'profession.qualification.name', '') || get(artistSuggested, 'profession.name');
          return (
            <div className={classes.suggestedArtist} key={`artistSuggested-${get(artistSuggested, 'id')}`}>
              <span>
                {`${get(artistSuggested, 'name')} ${profession ? `(${profession})` : ''}`}
                <NewWindowLink href={getRouteWithSlug(route.ARTISTS, artistSuggested)} withIcon />
              </span>
              <span>
                {get(artistSuggested, 'isInRoster') ? (
                  <NextLink
                    href={`${getRouteWithSlug(route.MANAGERS, agencyData)}/${
                      actionsPagesRoutes.ADD_AGREEMENTS
                    }?artist_id=${get(artistSuggested, 'connection_id')}`}
                  >
                    {t(`${TP}.m_ROSTER_BTN_EDIT_IN_ROSTER`)}
                  </NextLink>
                ) : (
                  <TextButton
                    onClick={() => {
                      selectArtist(artistSuggested);
                      closeModal();
                    }}
                  >
                    {t(`${TP}.m_ROSTER_SUGGESTED_SELECT`)}
                  </TextButton>
                )}
              </span>
            </div>
          );
        })}
      </div>
    </ActionStatusModal>
  );
};

SuggestionArtistsModal.propTypes = {
  agencyData: PropTypes.object.isRequired,
  artistSuggestionsList: PropTypes.array,
  closeModal: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  isOpened: PropTypes.bool,
  addToRoster: PropTypes.func,
  selectArtist: PropTypes.func,
  type: PropTypes.oneOf(['duplicate', 'list']),
  mainText: PropTypes.string,
  confirmButtonText: PropTypes.string,
};

SuggestionArtistsModal.defaultProps = {
  artistSuggestionsList: [],
  type: 'list',
  isOpened: false,
  addToRoster: () => {},
  selectArtist: () => {},
  mainText: `${TP}.m_ROSTER_POPUP_TEXT_SG`,
  confirmButtonText: `${TP}.m_ROSTER_BTN_ADD_NEW`,
};

export default SuggestionArtistsModal;
